import React from "react";
import dashboardclasses from "../../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "../../../App.css";
import Moment from "react-moment";
function Services({ Services }) {
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const columns = [
        {
            dataField: "title",
            text: "TITLE",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "mobile",
            text: "MOBILE",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "description",
            text: "DESCRIPTION",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "Amount",
            text: "CREDIT/DEBIT",
            sort: false,
            formatter: (cell, cellContent) => (
                <span
                    style={{
                        color: cellContent?.IsCredited == 1 ? "green" : "red",
                    }}>
                    ₹ {cell}
                </span>
            ),
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "created_at_formatted",
            text: "Transaction Date",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
    ];
    const pagination = paginationFactory({
        page: 1,
        sizePerPage: 15,
        lastPageText: ">>",
        firstPageText: "<<",
        nextPageText: ">",
        prePageText: "<",
        hideSizePerPage: true,
        showTotal: true,
        alwaysShowAllBtns: true,
        onPageChange: function (page, sizePerPage) {
            window.scrollTo({ top: 10, behavior: "instant" });
        },
        onSizePerPageChange: function (page, sizePerPage) {
            console.log("page", page);
            console.log("sizePerPage", sizePerPage);
        },
    });
    const emptyDataMessage = () => {
        return "No Data to Display";
    };
    return (
        <div>
            <div className="category-table">
                <BootstrapTable
                    bootstrap4
                    keyField="id"
                    data={Services}
                    columns={columns}
                    // defaultSorted={defaultSorted}
                    pagination={pagination}
                    wrapperClasses="table-responsive"
                    noDataIndication={emptyDataMessage}
                />
            </div>
        </div>
    );
}

export default Services;
